import { withChartLayout } from 'components/common';
import Activity from 'components/features/chart/basic-nursing-care/activity/Activity';

const ActivityPage = withChartLayout('Activity')(Activity);
export default ActivityPage;
